import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../_service/auth.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';

@Component({
  selector: 'fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css']
})
export class FileuploadComponent implements OnInit {
  
  constructor(private sanitizer: DomSanitizer, public authService: AuthService, public fb: FormBuilder) {
    this.accept = 'application/pdf';
  }
  
  @Input()
  mode;
  @Input()
  names;
  @Input()
  url;
  @Input()
  method;
  @Input()
  multiple;
  @Input()
  disabled;
  @Input()
  accept;
  @Input()
  maxFileSize;
  @Input()
  auto = true;
  @Input()
  withCredentials;
  @Input()
  invalidFileSizeMessageSummary;
  @Input()
  invalidFileSizeMessageDetail;
  @Input()
  invalidFileTypeMessageSummary;
  @Input()
  invalidFileTypeMessageDetail;
  @Input()
  previewWidth;
  @Input()
  chooseLabel = 'Upload';
  @Input()
  uploadLabel = 'Upload';
  @Input()
  cancelLabel = 'Cance';
  @Input()
  customUpload;
  @Input()
  showUploadButton;
  @Input()
  showCancelButton;
  @Input()
  dataUriPrefix;
  @Input()
  deleteButtonLabel;
  @Input()
  deleteButtonIcon = 'close';
  @Input()
  showUploadInfo;
  @Input()
  externalProductId;

  ngOnInit() {
    console.log(this.authService.decodedToken.role);
  }

  @ViewChild('fileUpload', { static: true })
  fileUpload: ElementRef;

  inputFileName: string;

  @Input()
  files: File[] = [];
  fileUrl: any = null;

  isHide = true;
  longLength = false;
  checkedTime = 0;

  hideOpenButton = false;

  onClick(event) {
    if (this.fileUpload) {
      this.fileUpload.nativeElement.click();
    }
  }

  onInput(event) {
    console.log(event);
  }

  // FileExists(file) {
  //   console.log(file);
  //   if (file) {
  //     return this.hideOpenButton = true;
  //   } else {
  //     return this.hideOpenButton = false;
  //   }
  // }

  onFileSelected(event) {
    const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    if (files[0].name.length > 25) {
      console.log('file');
      console.log(files[0].name.length);
      this.longLength = true;
      this.isHide = true;
      return null;
    }
    console.log('event::::::', event);
    let flag = false;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type != 'application/pdf') continue;

      if (this.validate(file)) {
        file.objectURL = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(files[i])));
        if (!this.isMultiple()) {
          this.files = [];
        }
        this.files.push(files[i]);
        flag = true;
        this.checkedTime++;
      }
    }
    if (files.length === 0) {
      this.longLength = false;
      this.isHide = true;
    }
    this.isHide = flag;
    this.longLength = false;
    // this.hideOpenButton = flag;
    if (this.isHide) { this.fileUrl = URL.createObjectURL(files[0]); }
  }

  removeFile(event, file) {
    this.hideOpenButton = false;
    let ix;
    // tslint:disable-next-line: no-conditional-assignment
    if (this.files && -1 !== (ix = this.files.indexOf(file))) {
      this.files.splice(ix, 1);
      this.clearInputElement();
    }
    this.fileUrl = null;
    this.files = [];
    this.checkedTime = 0;
  }

  validate(file: File) {
    for (const f of this.files) {
      if (f.name === file.name
        && f.lastModified === file.lastModified
        && f.size === f.size
        && f.type === f.type
      ) {
        return false;
      }
    }
    return true;
  }

  clearInputElement() {
    this.fileUpload.nativeElement.value = '';
  }


  isMultiple(): boolean {
    return this.multiple;
  }

  openFile() {
    if (this.checkedTime > 0 && this.fileUrl) {
      window.open(this.fileUrl, '_blank');
      return;
    }
    if (!this.externalProductId) { return; }
    const sdsUrl = `${window.location.origin}/view/${this.externalProductId}`;
    window.open(sdsUrl, '_blank');
  }
}